import graphql from "babel-plugin-relay/macro";

export default graphql`
query getOrgEventsQuery($orgId: ID!,$startAt: String,$endAt: String, $status: String, $search: String, $after: String, $before: String, $first: Int, $last: Int){
  orgHyevents(orgId:$orgId, startAt:$startAt, endAt:$endAt, status:$status, search:$search, after:$after, before:$before, first:$first, last:$last ){
      pageInfo {
        endCursor
        startCursor
        hasPreviousPage
        hasNextPage
      }
      edges {
        cursor
        node {
          id
          title
          propertyId
          propertyName
          startAt
          endAt
        }
      }
    }
  }` 